import { render, staticRenderFns } from "./indexpic.vue?vue&type=template&id=18349afe&scoped=true&"
import script from "./indexpic.vue?vue&type=script&lang=js&"
export * from "./indexpic.vue?vue&type=script&lang=js&"
import style0 from "./indexpic.vue?vue&type=style&index=0&id=18349afe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18349afe",
  null
  
)

export default component.exports